import React, { useContext, useState, useEffect } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Fragment } from 'react'
import { AuthContext } from '../../../App/App'
import swal from 'sweetalert';
import axios from 'axios';
import qs from 'querystring'

function ChatCategory() {
    const { stateAuth, dispatchAuth } = useContext(AuthContext)

    const getChatCategories = () => {
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }
        axios.get('/api/v1/helpdesk/setting/category/categories', config)
            .then(res => {
                setdataForm({
                    ...dataForm,
                    firsload: false,
                    categories: res.data.data,
                })
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again...'
                        })
                    } else {
                        swal("Error!", `${err.response.data.message}`, "error", {
                            button: "OK",
                        });
                    }
                }
            })
    }

    const deleteChatCategory = () => {
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }
        axios.delete(`/api/v1/helpdesk/setting/category/category/${inputDataForm.tempDelete.id}`, config)
            .then(res => {
                getChatCategories()

                handleCanceClick()

                swal("Success!", "Chat Category has been deleted!", "success", {
                    button: "OK",
                });
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again...'
                        })
                    } else {
                        swal("Error!", `${err.response.data.message}`, "error", {
                            button: "OK",
                        });
                    }
                }
            })
    }

    const addChatCategory = () => {
        const reqBody = {
            category_name: inputDataForm.add,
            category_order: inputDataForm.addOrder
        }
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }
        axios.post(`/api/v1/helpdesk/setting/category/category/${dataForm.selectedClient}`, qs.stringify(reqBody), config)
            .then(res => {
                setinputDataForm({
                    ...inputDataForm,
                    add: '',
                    addOrder: '',
                    errCategory: null,
                    errOder: null
                })
                getChatCategories()
                swal("Success!", "Chat Category has been added!", "success", {
                    button: "OK",
                });
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again...'
                        })

                    } else if (err.response.data.status === 'invalid') {
                        let category = null
                        let order = null
                        err.response.data.errors.map(err => {
                            category = (err.param === 'category_name') ? err.msg : category
                            order = (err.param === 'category_order') ? err.msg : order
                        })
                        setinputDataForm({
                            ...inputDataForm,
                            errCategory: category,
                            errOder: order
                        })
                    } else {
                        swal("Error!", `${err.response.data.message}`, "error", {
                            button: "OK",
                        });
                    }
                }
            })
    }

    const editCategory = () => {
        const reqBody = {
            category_name: inputDataForm.tempEdit.name,
            category_order: inputDataForm.tempEdit.order
        }
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }
        axios.put(`/api/v1/helpdesk/setting/category/category/${inputDataForm.tempEdit.id}`, qs.stringify(reqBody), config)
            .then(res => {
                setinputDataForm({
                    ...inputDataForm,
                    tempEdit: { id: null, name: '', order: '' },
                    edited: false,
                    errEditCategory: null,
                    errEditOrder: null,
                })
                getChatCategories()
                swal("Success!", "Chat Category has been added!", "success", {
                    button: "OK",
                });
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again...'
                        })
                    } else if (err.response.data.status === 'invalid') {
                        let category = null
                        let order = null
                        err.response.data.errors.map(err => {
                            category = (err.param === 'category_name') ? err.msg : category
                            order = (err.param === 'category_order') ? err.msg : order
                        })
                        setinputDataForm({
                            ...inputDataForm,
                            errEditCategory: category,
                            errEditOrder: order
                        })
                    } else {
                        swal("Error!", `${err.response.data.message}`, "error", {
                            button: "OK",
                        });
                    }
                }
            })
    }

    const handleClientClick = (id) => {
        setinputDataForm(initialInputDataForm)
        setdataForm({
            ...dataForm,
            selectedClient: id
        })
    }

    const handleDeleteClick = (data) => {
        if (inputDataForm.edited == true && inputDataForm.tempEdit.id == data.id) {
            //cancel
            setinputDataForm({
                ...inputDataForm,
                tempEdit: { id: null, name: '', order: '' },
                edited: false,
                errEditCategory: null,
                errEditOrder: null,
            })
        } else if (data.id != inputDataForm.tempEdit.id) {
            //delete
            setinputDataForm({
                ...inputDataForm,
                tempDelete: {
                    id: data.id,
                    name: data.name,
                    order: data.order
                }
            })
            setModalDelete({
                ...modalDelete,
                status: true
            })
        }
    }

    const handleEditClick = (data) => {
        if (inputDataForm.edited == true && inputDataForm.tempEdit.id == data.id) {
            //save
            if (inputDataForm.tempEdit.name != '' && inputDataForm.tempEdit.order != '') {
                editCategory()
            } else {
                setinputDataForm({
                    ...inputDataForm,
                    errEditCategory: 'Fill category name',
                    errEditOrder: 'Fill order',
                })
            }
        } else if (data.id != inputDataForm.tempEdit.id) {
            setinputDataForm({
                ...inputDataForm,
                edited: true,
                tempEdit: {
                    id: data.id,
                    name: data.name,
                    order: data.order
                }
            })
        }
    }

    const handleCanceClick = (event) => {
        event.preventDefault()
        setinputDataForm({
            ...inputDataForm,
            tempDelete: null
        })

        setModalDelete({
            ...modalDelete,
            status: false
        })
    }

    const handleChangeAdd = (event) => {
        event.preventDefault();
        if (event.target.validity.valid) {
            setinputDataForm({
                ...inputDataForm,
                [event.target.name]: event.target.value,
                errCategory: (event.target.name === 'add') ? (event.target.value != '') ? null : 'Fill category name' : inputDataForm.errCategory,
                errOder: (event.target.name === 'addOrder') ? (event.target.value != '') ? null : 'Fill order' : inputDataForm.errOder,
            })
        }
    }

    const handleChangeEdit = (event) => {
        event.preventDefault();
        if (event.target.validity.valid) {
            setinputDataForm({
                ...inputDataForm,
                tempEdit: {
                    id: inputDataForm.tempEdit.id,
                    name: event.target.name == "edit-categoy" ? event.target.value : inputDataForm.tempEdit.name,
                    order: event.target.name == "edit-order" ? event.target.value : inputDataForm.tempEdit.order,
                },
                errEditCategory: event.target.name == "edit-categoy" ? (event.target.value != '') ? null : 'Fill category name' : inputDataForm.errEditCategory,
                errEditOrder: event.target.name == "edit-order" ? (event.target.value != '') ? null : 'Fill order' : inputDataForm.errEditOrder
            })
        }
    }

    const handleAddCategory = (event, action) => {
        event.preventDefault();
        if (action === 'action') {
            setinputDataForm({
                ...inputDataForm,
                addStatus: !inputDataForm.addStatus,
                add: '',
                addOrder: '',
                errCategory: null,
                errOder: null
            })
        } else {
            if (inputDataForm.add != '' && inputDataForm.addOrder != '') {
                addChatCategory()
            } else {
                setinputDataForm({
                    ...inputDataForm,
                    errCategory: (inputDataForm.add != '') ? inputDataForm.errCategory : 'Please enter category name.',
                    errOder: (inputDataForm.addOrder != '') ? inputDataForm.errOder : 'Fill order.',
                })
            }
        }
    }

    const [modalDelete, setModalDelete] = useState({ status: false, render: <Fragment /> })

    useEffect(() => {
        if (modalDelete.status == true && inputDataForm.tempDelete != null) {
            setModalDelete({
                ...modalDelete,
                render: (
                    <Fragment>
                        <Modal className="modal-dialog modal-dialog-centered" isOpen={modalDelete.status} backdrop={true} keyboard={true}>
                            <ModalHeader toggle={handleCanceClick} charCode={<i className="fas fa-times-circle" style={{ fontSize: '20px' }}></i>}>
                                Delete Category
                            </ModalHeader>
                            <ModalBody>
                                <p>Are you sure you want to delete your this category?</p>
                                <ul style={{ listStyleType: 'none' }}>
                                    <li>Name : {inputDataForm.tempDelete.name}</li>
                                    <li>Order : {inputDataForm.tempDelete.order}</li>
                                </ul>
                            </ModalBody>
                            <ModalFooter>
                                <Button style={{ textTransform: 'capitalize' }} color="secondary" onClick={handleCanceClick}>Cancel</Button>
                                <Button style={{ textTransform: 'capitalize' }} color="danger" onClick={deleteChatCategory}>Delete <i className="fas fa-eraser"></i> </Button>
                            </ModalFooter>
                        </Modal>
                    </Fragment>
                )
            })
        } else {
            setModalDelete({
                ...modalDelete,
                render: <Fragment />
            })
        }
    }, [modalDelete.status])

    const initialDataForm = {
        firsload: true,
        categories: null,
        selectedClient: null
    }
    const [dataForm, setdataForm] = useState(initialDataForm)
    useEffect(() => {
        if (dataForm.firsload == true) {
            getChatCategories()
        }
    }, [dataForm.firsload])

    const initialInputDataForm = {
        addStatus: false,
        add: '',
        addOrder: '',
        errCategory: null,
        errOder: null,
        tempDelete: null,
        tempEdit: { id: null, name: '', order: '' },
        edited: false,
        errEditCategory: null,
        errEditOrder: null,
    }
    const [inputDataForm, setinputDataForm] = useState(initialInputDataForm)

    const initialState = {
        header: null,
        client: null,
        category: null
    }
    const [renderChatCategory, setrenderChatCategory] = useState(initialState)

    useEffect(() => {
        if (dataForm.categories != null) {
            const renderClient = []
            const renderCategory = []
            dataForm.categories.map((content, index) => {
                //init selected client
                if (dataForm.selectedClient == null && index == 0) {
                    setdataForm({
                        ...dataForm,
                        selectedClient: content.client_id
                    })
                }

                renderClient.push(
                    <div key={content.client_id} className="nav-item" key={content.client_id} >
                        <a onClick={handleClientClick.bind(this, content.client_id)} className={`nav-link m-1 ${(dataForm.selectedClient == null && index == 0) ? 'active' : dataForm.selectedClient == content.client_id ? 'active' : ''}`} id={`tab-${content.client_id}`} data-toggle="tab" href={`#${content.client_id}`} role="tab" aria-selected={index == 0 ? 'true' : ''} style={{ textTransform: 'capitalize', fontSize: '20px' }}>{content.client_name}</a>
                    </div>
                )

                renderCategory.push(
                    <div key={content.client_id} className={`tab-pane fade ${content.client_id == dataForm.selectedClient ? 'show active' : ''}`} id={`${content.client_id}`} role="tabpanel" aria-labelledby={`tab-${content.client_id}`}>
                        <div className="form-group col-12 mb-0">
                            <div className="input-group pt-1">
                                <input type="text" disabled={!inputDataForm.addStatus} className={`form-control ${inputDataForm.errCategory != null ? 'is-invalid' : ''}`} autoFocus placeholder="Clcik 'Add New' Button to add new category" id="add" name="add" value={inputDataForm.add} onChange={handleChangeAdd} />
                                <input type="text" disabled={!inputDataForm.addStatus} pattern="[0-9]*" className={`form-control col-2 ${inputDataForm.errOder != null ? 'is-invalid' : ''}`} autoFocus placeholder="Order" id="addOrder" name="addOrder" style={{ textAlign: 'center' }} value={inputDataForm.addOrder} onChange={handleChangeAdd} />
                                {inputDataForm.addStatus ? (
                                    <Fragment>
                                        <div className="input-group-append" >
                                            <button onClick={(e) => handleAddCategory(e, 'add')} className="btn btn-success " type="button" style={{ textTransform: 'capitalize', width: '100px' }}>Add</button>
                                        </div>
                                        <div className="input-group-append" >
                                            <button onClick={(e) => handleAddCategory(e, 'action')} className="btn btn-secondary" type="button" style={{ textTransform: 'capitalize', width: '100px' }}>Cancel</button>
                                        </div>
                                    </Fragment>
                                ) : (
                                    <div className="input-group-append">
                                        <button onClick={(e) => handleAddCategory(e, 'action')} className="btn btn-success" type="button" style={{ textTransform: 'capitalize', width: '200px' }}>Add New</button>
                                    </div>
                                )}

                            </div>
                            <div className="row col-12 p-0 mb-2">
                                <div className="col-8" style={{ fontWeight: 'bolder', textAlign: 'start', color: 'red' }}><small>{inputDataForm.errCategory}</small></div>
                                <div className="col-2" style={{ fontWeight: 'bolder', textAlign: 'start', color: 'red' }}><small>{inputDataForm.errOder}</small></div>
                            </div>
                        </div>
                        {content.category.map((category) =>
                        (<div className="form-group col-12 pt-1 mb-0" key={category.category_id}>
                            <div className="input-group mb-0">
                                <input type="text" className={`form-control ${inputDataForm.tempEdit.id === category.category_id && inputDataForm.errEditCategory !== null ? 'is-invalid' : ''}`} disabled={inputDataForm.tempEdit.id == category.category_id ? false : true} autoFocus id="edit-categoy" name="edit-categoy" value={inputDataForm.tempEdit.id == category.category_id ? inputDataForm.tempEdit.name : category.category_name} onInput={handleChangeEdit} />
                                <input type="text" pattern="[0-9]*" className={`form-control ${inputDataForm.tempEdit.id === category.category_id && inputDataForm.errEditOrder !== null ? 'is-invalid' : ''} col-2 `} disabled={inputDataForm.tempEdit.id == category.category_id ? false : true} autoFocus id="edit-order" name="edit-order" style={{ WebkitAppearance: 'none', MozAppearance: 'textfield', textAlign: 'center' }} value={inputDataForm.tempEdit.id == category.category_id ? inputDataForm.tempEdit.order : category.order} onInput={handleChangeEdit} />
                                <div className="input-group-append" >
                                    <button onClick={handleEditClick.bind(this, { id: category.category_id, name: category.category_name, order: category.order })} className={`btn btn-${inputDataForm.tempEdit.id == category.category_id ? 'warning' : 'primary'}`} type="button" style={{ textTransform: 'capitalize', width: '100px' }}>{inputDataForm.tempEdit.id == category.category_id ? 'Save' : 'Edit'}</button>
                                </div>
                                <div className="input-group-append" >
                                    <button onClick={handleDeleteClick.bind(this, { id: category.category_id, name: category.category_name, order: category.order })} className={`btn btn-${inputDataForm.tempEdit.id == category.category_id ? 'secondary ' : 'danger'}`} type="button" style={{ textTransform: 'capitalize', width: '100px' }}>{inputDataForm.tempEdit.id == category.category_id ? 'Cancel' : 'Delete'}</button>
                                </div>
                            </div>
                            {(inputDataForm.tempEdit.id === category.category_id && (inputDataForm.errEditCategory !== null || inputDataForm.errEditOrder !== null)) ? (
                                <div className="row col-12 p-0 mb-2">
                                    <div className="col-8" style={{ fontWeight: 'bolder', textAlign: 'start', color: 'red' }}><small>{inputDataForm.errEditCategory}</small></div>
                                    <div className="col-2" style={{ fontWeight: 'bolder', textAlign: 'start', color: 'red' }}><small>{inputDataForm.errEditOrder}</small></div>
                                </div>
                            ) : <Fragment />}
                        </div>)
                        )}
                    </div>
                )

            })
            setrenderChatCategory({
                ...renderChatCategory,
                header: (
                    <div className="row justify-content-center col-12 m-0">
                        <div className="col-3 pb-0 mb-0" style={{ fontWeight: 'bolder', fontSize: '20px', textAlign: 'center' }}>Client Type</div>
                        <div className="col-9 col-lg-8 pb-0 mb-0">

                            <div className="row col-12 pb-2 pr-3">
                                <div className="col-8" style={{ fontWeight: 'bolder', fontSize: '20px', textAlign: 'center' }}>Category</div>
                                <div className="col-2" style={{ fontWeight: 'bolder', fontSize: '20px', textAlign: 'center' }}>Order</div>
                                <div className="col-2" style={{ fontWeight: 'bolder', fontSize: '20px', textAlign: 'center' }}>Action</div>
                            </div>
                        </div>
                    </div>
                ),
                client: (
                    <Fragment>
                        {renderClient}
                    </Fragment>
                ),
                category: (
                    <Fragment>
                        {renderCategory}
                    </Fragment>
                )
            })
        }
    }, [dataForm.categories, dataForm.selectedClient, inputDataForm, modalDelete])

    return (
        <Fragment>
            <div className="col-12 col-md-12 col-lg-12" >
                <div className="card" style={{ minHeight: '85vh' }}>
                    <div className="card-body col-12">
                        <div className="section-title mt-0 pb-4">
                            {stateAuth.page}
                        </div>
                        {renderChatCategory.header}
                        <div className="row justify-content-center col-12 m-0">
                            <div className="col-3 pb-0 mb-0">
                                <ul className="nav nav-pills flex-column" id="myTab4" role="tablist">
                                    {renderChatCategory.client}
                                </ul>
                            </div>
                            <div className="col-9 col-lg-8">
                                <div className="tab-content no-padding" id="myTab2Content">
                                    {renderChatCategory.category}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {modalDelete.render}
        </Fragment>
    )
}

export default ChatCategory
